let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("iou9M")]).then(() => parcelRequire('kgixI'));